import { FreeTrialButton } from "../free-trial-button";
import { RequestDemoButton } from "../request-demo-button";

export const Actions = () => {
  return (
    <div
      css={`
        display: flex;
        flex-direction: column;
        gap: 16px;

        @media (min-width: 1000px) {
          flex-direction: row;
        }
      `}
    >
      <FreeTrialButton />
      <RequestDemoButton />
    </div>
  );
};
